import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { VentanaFlotante } from 'src/app/hojas-call-center/models/VentanaFlotante';
import { MsalService } from '@azure/msal-angular';
import { GestionPeticionService } from 'src/app/hojas-call-center/services/bd/GestionPeticion/gestion-peticion.service';
import { ComentarioContact } from '../detalle-peticion.component';

@Component({
  selector: 'ral-comentario',
  templateUrl: './comentario.component.html',
  styleUrls: ['./comentario.component.scss']
})
export class ComentarioComponent extends VentanaFlotante  implements OnInit
{
  comentarioNuevo:ComentarioContact = {linea:0,created:"",obser:"",usuario:""};
  nombreUsuario: string ="";
  idPeticion:number = 0;
  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private msalService: MsalService, // Additional parameter to override in the constructor
    private peticionService:GestionPeticionService
  ) {
    super(dialogRef, data); // Call the parent class constructor
  }
  ngOnInit(): void
  {
    this.cargarUser();
    this.cargarPropiedadesComentario();
  }

  private cargarUser():void
  {
    const account=  this.msalService.instance.getActiveAccount();

    this.nombreUsuario = account?.name || "";
    this.nombreUsuario = account?.username.replace("@ralarsa.com","") || "";
    if(this.nombreUsuario.length>15)
    {
      this.nombreUsuario = this.nombreUsuario.substring(0,14);
    }
  }

  cargarPropiedadesComentario()
  {
    this.comentarioNuevo.usuario = this.nombreUsuario;
    this.comentarioNuevo.linea = this.data.numNuevaLinea;
    this.idPeticion = this.data.idPeticion;
  }

  agregarComentario()
  {
   this.comentarioNuevo.created = this.getHoy();
   if (this.data.tipo == "TUVOZ"){
     this.peticionService.insertarLineaCoris(this.data.token,this.idPeticion,this.comentarioNuevo).then(res=>
     {
       this.dialogRef.close(this.comentarioNuevo);
     }).catch(err => {
       alert("No se ha podido insertar el comentario.");
     });
   }else if(this.data.tipo == "alphabet" || this.data.tipo == "drivalia"){
     this.peticionService.insertarLineaAlphabet(this.data.token,this.idPeticion,this.comentarioNuevo).then(res=>
     {
       this.dialogRef.close(this.comentarioNuevo);
     }).catch(err => {
       alert("No se ha podido insertar el comentario.");
     });
   } else{
     this.peticionService.InsertarLineaComentario(this.data.token,this.idPeticion,this.comentarioNuevo,this.data.tipo)
       .then(res=>
       {
         this.dialogRef.close(this.comentarioNuevo);
       }).catch(err => {
       alert("No se ha podido insertar el comentario.");
     });
   }
  }
  private getHoy():string
  {
    const currentDate = new Date();
    return currentDate.toLocaleString('es-ES',
    {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
